import { useFlags } from '@atlaskit/flag';
import { useRef } from 'react';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import { token } from '@atlaskit/tokens';

export const useEventErrorFlag = (title?: string, description?: string) => {
  const flagCount = useRef(1);

  const { showFlag } = useFlags();

  const flagTitle = title ?? 'Something went wrong';
  const flagDescription = description ?? 'Wait a few moments, then try again.';

  const addFlag = () => {
    const id = flagCount.current++;
    showFlag({
      description: flagDescription,
      icon: (
        <CrossCircleIcon
          label="Error"
          primaryColor={token('color.icon.danger')}
        />
      ),
      id: id,
      title: flagTitle,
    });
  };
  return addFlag;
};
